import { apiKey } from '../config/config'

function appendScript() {
  console.log('appending script...')
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initMap`
  document.body.appendChild(script)
}

export default appendScript



// WEBPACK FOOTER //
// ./src/mapSetup/appendScript.js